export * from "./dist/search-insights-browser.mjs";
import aa from "./dist/search-insights-browser.mjs";
export default aa;